import useQueryState from '../../../../../../shared/hooks/useQueryState'
import useMaintenanceBlankSchema from '../../../../../Processes/Maintenance/hooks/useMaintenanceBlankSchema'
import useMaintenanceProcessRule from '../../../../hooks/useMaintenanceProcessRule'
import { IMaintenanceProcessRule } from '../../../../../Processes/Maintenance/maintenance.types'

const useCreatePlannedMaintenanceBlankSidePageCtrl = () => {
  const [processRuleIdQuery, setProcessRuleIdQuery] = useQueryState<number>('processRuleId', null)
  const processRule = useMaintenanceProcessRule(processRuleIdQuery)
  const blankSchemaId = processRule?.blankSchemaId
  const blankSchema = useMaintenanceBlankSchema(+blankSchemaId)

  return {
    processRuleId: processRule?.id,
    blankSchema,
    clearProcessRuleIdState: () => setProcessRuleIdQuery(null),
    handleProcessRuleIdChange: (value: IMaintenanceProcessRule['id']) => setProcessRuleIdQuery(value),
    open: blankSchema?.id != null,
  }
}

export default useCreatePlannedMaintenanceBlankSidePageCtrl
